import type { KeyboardEvent } from 'react'
import { MarkdownActions } from '../MarkdownEditorState/actions'

export const handleToolbarShortcutsKeyDown = (
  e: KeyboardEvent<HTMLTextAreaElement>,
  actions: MarkdownActions,
): boolean => {
  const isMod = e.metaKey || e.ctrlKey
  const key = e.key.toLowerCase()

  if (!isMod) return false

  if (e.altKey) {
    switch (key) {
      case 'c':
        e.preventDefault()
        actions.insertCodeBlock()
        return true
      case 't':
        e.preventDefault()
        actions.insertTable()
        return true
      default:
        break
    }
  }

  if (e.shiftKey) {
    switch (key) {
      case 'x':
        e.preventDefault()
        actions.toggleStrike()
        return true
      case 'l':
        e.preventDefault()
        actions.toggleUnorderedList()
        return true
      case 'o':
        e.preventDefault()
        actions.toggleOrderedList()
        return true
      case 'b':
        e.preventDefault()
        actions.toggleQuote()
        return true
      case 'c':
        e.preventDefault()
        actions.toggleInlineCode()
        return true
      default:
        break
    }
  } else {
    switch (key) {
      case 'b':
        e.preventDefault()
        actions.toggleBold()
        return true
      case 'i':
        e.preventDefault()
        actions.toggleItalic()
        return true
      case 'k':
        e.preventDefault()
        actions.insertLink()
        return true
      case 'd':
        e.preventDefault()
        actions.duplicate()
        return true
      default:
        break
    }
  }

  return false
}
